import { Bell, Search } from 'lucide-react';
import { type ReactNode } from 'react';

import { AppSidebar, type Role } from './AppSidebar';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';

interface Props {
  role: Role;
  user: { name: string; subtitle: string; initials: string };
  children: ReactNode;
}

export const DashboardLayout = ({ role, user, children }: Props) => (
  <SidebarProvider>
    <div className="flex min-h-screen w-full bg-muted/30">
      <AppSidebar role={role} />
      <div className="flex min-h-screen flex-1 flex-col">
        <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-border bg-background/80 px-4 backdrop-blur lg:px-6">
          <SidebarTrigger className="text-muted-foreground" />
          <div className="hidden flex-1 items-center md:flex">
            <div className="relative w-full max-w-sm">
              <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
              <Input placeholder="Rechercher campagne, participant, code…" className="h-9 pl-9" />
            </div>
          </div>
          <div className="ml-auto flex items-center gap-2">
            <Button variant="ghost" size="icon" aria-label="Notifications" className="relative">
              <Bell className="size-4" />
              <span className="absolute right-2 top-2 size-2 rounded-full bg-primary" />
            </Button>
            <div className="flex items-center gap-3 rounded-full border border-border bg-card py-1 pl-3 pr-1">
              <div className="hidden text-right sm:block">
                <p className="text-sm font-semibold leading-tight text-foreground">{user.name}</p>
                <p className="text-xs leading-tight text-muted-foreground">{user.subtitle}</p>
              </div>
              <div className="grid size-8 place-items-center rounded-full bg-gradient-primary font-display text-xs font-bold text-primary-foreground">
                {user.initials}
              </div>
            </div>
          </div>
        </header>
        <main className="flex-1 px-4 py-6 lg:px-8 lg:py-8">{children}</main>
      </div>
    </div>
  </SidebarProvider>
);
